import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvSelectComponent, MarvSelectItem } from '@marv/components';
import { PermanentAgentService } from '@app/services';

@Component({
    selector: 'app-permanent-agent-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class PermanentAgentSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('AGENT');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'person-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'agentId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'agents', required : false}) agents: Array<MarvSelectItem>;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;

    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService
    ) { }

    async ngOnInit() {
        let items: Array<MarvSelectItem> = [];
        if(typeof this.agents !== 'undefined'){
            items = this.agents;
        }
        else{
            let agents = PermanentAgentService.PermanentsAgents;
            if(agents){
                for(let agent of agents){
                    items.push(new MarvSelectItem(agent.name,agent.id));
                }
            }
        }
        this.items = items;
    }

}
